export default "__VITE_PUBLIC_ASSET__45aad8d5__"